module.exports = __webpack_public_path__ + "static/media/4042.f70f6487.gif";